import { stringify as stringifyQs } from "qs";

import { Dialog } from "../../types";

export const ReportsUrl = "/reports/";
export type GenerateReportUrlDialog = "generate";
export type GenerateReportUrlQueryParams = Dialog<GenerateReportUrlDialog>;
export const generateReportUrl = (params?: GenerateReportUrlQueryParams) =>
  ReportsUrl + "?" + stringifyQs(params);
